import { z } from 'zod'

const booleanSearchParam = z
  .preprocess((value) => value === true || value === 'true', z.boolean())
  .catch(false)

export const platformUserSearchSchema = z.object({
  search: z.string().max(200).optional().catch(undefined),
  status: z.enum(['all', 'active', 'lockedOut', 'disabled']).catch('all'),
  lastLoginFrom: z.iso.date().optional().catch(undefined),
  lastLoginTill: z.iso.date().optional().catch(undefined),
  hasInternships: booleanSearchParam,
  hasOrgs: booleanSearchParam,
  hasEduOrgs: booleanSearchParam,
  page: z.coerce.number().int().min(1).catch(1),
  pageSize: z.coerce
    .number()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(10),
  sortBy: z
    .enum(['firstname', 'lastname', 'status', 'email', 'roles', 'lastlogin'])
    .catch('lastname'),
  direction: z.enum(['asc', 'desc']).catch('asc'),
})

export type PlatformUserSearch = z.infer<typeof platformUserSearchSchema>

export const defaultPlatformUserSearch: PlatformUserSearch = {
  status: 'all',
  hasInternships: false,
  hasOrgs: false,
  hasEduOrgs: false,
  page: 1,
  pageSize: 10,
  sortBy: 'lastname',
  direction: 'asc',
}
